import { TYPES } from 'action-types/auth';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { generateErrors } from 'utilities/util';
import { IStore } from 'reducers/index';
import { callApiGet } from 'utilities/apiCaller';
import { CONFIG } from 'configs/index';

export const checkTokenStatus = () => {
     return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({type: TYPES.TOKEN.PENDING});
        try {
            const res = await callApiGet(`${CONFIG.MSAL.instance}/consumer/oauth2/v2.0/authorize`);
            dispatch({type: TYPES.TOKEN.FULFILLED, tokenState: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({type: TYPES.TOKEN.REJECTED, errors})
        }
    }
}
export const detectAuthStatus = () => {
    return (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({type: TYPES.LOGIN.PENDING});
        try {
            dispatch({type: TYPES.LOGIN.FULFILLED});
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({type: TYPES.LOGIN.REJECTED, errors})
        }
    }
}
